<template>
  <div class="hei100">
    <div class="list-head" @click.self="backTop">
      <div class="tabs" :class="current ? '' : 'selected'" @click="current = 0">
        待取件<span>{{ userExpressNumDTO.waitPickingNum }}</span>
      </div>
      <div class="tabs" :class="current ? 'selected' : ''" @click="current = 1">
        已签收<span>{{ userExpressNumDTO.pickedNum }}</span>
      </div>
    </div>
    <div id="list">
      <van-pull-refresh
        v-model="isRefresh"
        :head-height="80"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div class="list-main">
            <div
              class="list-item"
              v-for="(item, index) in siteList"
              :key="index"
            >
              <div class="site-info">
                <van-image width="40" height="40" :src="item.siteHeadImg" />
                <div class="site-text">
                  <div>
                    <span> {{ `${item.siteName}` }}</span>
                    <span style="color:#a30014">{{
                      `（${item.siteTotal}）`
                    }}</span>
                  </div>
                  <div style="font-size:14px">{{ item.siteAddress }}</div>
                </div>
                <!-- <div class="express-num" v-if="current === 0">
                  {{ item.siteTotal }}
                </div> -->
              </div>
              <div
                class="express-item"
                v-for="(i, k) in item.expressList"
                :key="k"
              >
                <div class="logo">
                  <van-image width="45" height="45" :src="i.companyImg" />
                </div>
                <div class="detail">
                  <div class="code">
                    {{
                      current === 0
                        ? i.discernCode
                          ? i.discernCode
                          : i.pickupCode
                        : '已签收'
                    }}
                  </div>
                  <div>{{ i.customerPhone }}的快递</div>
                  <div>{{ i.companyName }}：{{ i.expressCode }}</div>
                  <div>
                    {{ current === 0 ? '入库时间：' : '签收时间：'
                    }}{{ current === 0 ? i.inStoreTime : i.qsTime }}
                  </div>
                </div>
                <div class="flex committed" v-if="i.pickupStatus === 1">
                  <van-icon
                    name="checked"
                    color="#a30014"
                    size="16px"
                    style="margin-right:5px"
                  />
                  已提交
                </div>
              </div>
              <div class="oneClick">
                <div
                  class="expand flex"
                  v-if="item.expressList.length !== item.siteTotal"
                  @click="expandMore(item)"
                >
                  展开更多
                </div>
                <!-- <van-button
                  color="#a30014"
                  size="small"
                  class="btn1"
                  plain
                  @click="expandMore(item)"
                  v-if="item.expressList.length !== item.siteTotal"
                  >展开更多</van-button
                > -->
                <van-button
                  color="#a30014"
                  size="small"
                  class="btn"
                  @click="showPopup(item)"
                  v-show="!current"
                  >一键取件</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
        <van-empty description="您目前暂无快件" v-if="siteList.length === 0" />
      </van-pull-refresh>
    </div>
    <popup
      ref="popup"
      :list="pickList"
      :siteId="siteId"
      @close="closePopup"
      v-if="show"
      @refresh="onRefresh"
    />
  </div>
</template>
<script>
import Popup from './components/popup'
export default {
  data() {
    return {
      longLat: null,
      current: 0, // 0待取件，1已签收
      isRefresh: false,
      loading: false,
      finished: false,
      currentPage: 0,
      siteList: [],
      height: 0,
      userExpressNumDTO: [],
      pickList: [],
      siteId: '',
      show: false
    }
  },
  components: {
    Popup
  },
  created() {
    // this.getList()
    this.height = document.documentElement.clientHeight - 42 + 'px'
  },
  watch: {
    current(newV, oldV) {
      if (newV !== oldV) {
        this.changeTabs()
      }
    }
  },
  methods: {
    onLoad() {
      this.currentPage++
      this.getList()
    },
    getList() {
      let obj = JSON.parse(localStorage.getItem('userInfo'))
      let params = {
        appId: obj.appId,
        expressType: this.current + 1,
        openId: obj.openId,
        pageNum: this.currentPage,
        pageSize: 5
      }
      // let params = {
      //   appId: 'wx0a3c5448c56895a2',
      //   expressType: this.current + 1,
      //   openId: 'oP-g4v1ui8AdP3YOUdhtP9uhcJ7U',
      //   pageNum: this.currentPage,
      //   pageSize: 5
      // }
      // console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .oneKeyPickUpList(data)
        .then(res => {
          this.siteList = this.siteList.concat(res.siteExpressList)
          for (let i of this.siteList) {
            i.expressList = this.sortArray(i.expressList)
          }
          this.userExpressNumDTO = res.userExpressNumDTO
          this.loading = false
          this.isRefresh = false
          if (res.siteExpressList.length === 0) {
            this.finished = true // 全部数据加载完了
          } else {
            this.finished = false
          }
        })
        .catch(() => {
          this.loading = false
          this.isRefresh = false
          this.finished = true
        })
    },
    changeTabs() {
      this.onRefresh()
    },
    showPopup(item) {
      let params = {
        siteId: item.siteId,
        customerPhone: item.expressList[0].customerPhone, // '18350953860'
        expressStatus: 3,
        expressType: 0,
        orderType: 4,
        pageNum: 1,
        pageSize: item.siteTotal
      }
      // console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.expandMoreApi(data).then(res => {
        if (res.code === 0) {
          let array = []
          for (let i of res.siteExpressFilterList) {
            if (i.pickupStatus !== 1 && i.pickupStatus !== 2) {
              let obj = {
                companyImg: i.expressCompanyImg,
                companyName: i.expressCompanyName,
                customerPhone: i.customerPhone,
                discernCode: i.discernCode,
                expressCode: i.expressCode,
                expressId: i.expressId,
                inStoreTime: i.inStoreTime,
                pickupCode: i.randomCode,
                qsTime: i.qsTime
              }
              array.push(obj)
            }
          }
          if (array.length === 0) {
            this.$toast({
              type: 'fail',
              message: '您没有未提交申请的快件',
              forbidClick: true
            })
            return
          }
          this.pickList = []
          this.pickList = this.pickList.concat(array)
          this.siteId = item.siteId
          this.show = true
          this.$nextTick(() => {
            this.$refs.popup.show = true
          })
        }
      })
    },
    formatDate(time) {
      return this.$format(time)
    },
    sortArray(array) {
      array = array.sort((a, b) => {
        let result
        if (a.pickupStatus !== b.pickupStatus && a.pickupStatus === 1) {
          result = 1
        } else {
          result = -1
        }
        return result
      })
      return array
    },
    onRefresh() {
      console.log('refresh')
      this.currentPage = 1
      this.siteList = []
      this.getList()
    },
    expandMore(item) {
      let params = {
        siteId: item.siteId,
        customerPhone: item.expressList[0].customerPhone, // '18350953860'
        expressStatus: this.current === 0 ? 3 : 4,
        expressType: 0,
        orderType: this.current === 0 ? 4 : 6,
        pageNum: Math.floor(item.expressList.length / 10) + 1,
        pageSize: this.current === 0 ? item.siteTotal : 10
      }
      console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.expandMoreApi(data).then(res => {
        if (res.code === 0) {
          let array = []
          this.siteList.siteTotal = res.total
          for (let i of res.siteExpressFilterList) {
            let obj = {
              companyImg: i.expressCompanyImg,
              companyName: i.expressCompanyName,
              customerPhone: i.customerPhone,
              discernCode: i.discernCode,
              expressCode: i.expressCode,
              expressId: i.expressId,
              inStoreTime: i.inStoreTime,
              pickupCode: i.randomCode,
              qsTime: i.qsTime,
              pickupStatus: i.pickupStatus
            }
            array.push(obj)
          }
          array = this.sortArray(array)
          if (array.length === 0) {
            this.$toast.fail('没有更多了')
            return
          }
          if (item.expressList.length < 10) {
            item.expressList = []
          }
          item.expressList = item.expressList.concat(array)
        }
      })
    },
    closePopup() {
      this.show = false
    },
    backTop() {
      let timer = setInterval(() => {
        let scrollTop = document.getElementsByClassName('van-pull-refresh')[0]
          .scrollTop
        let ispeed = Math.floor(-scrollTop / 6)
        if (scrollTop === 0) {
          clearInterval(timer)
          this.isRefresh = true
          this.onRefresh()
        }
        document.getElementsByClassName(
          'van-pull-refresh'
        )[0].scrollTop += ispeed
      }, 16)
    }
  }
}
</script>
<style lang="scss" scoped>
#list {
  height: calc(100vh - 42px);
}
.hei100 {
  box-sizing: border-box;
  font-size: 12px;
}
.list-head {
  position: sticky;
  top: 0;
  // width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #f2f2f2;
  border-bottom: 1px solid #d7d7d7;
  .tabs {
    margin: 0 10px;
    font-size: 16px;
    span {
      margin-left: 5px;
    }
  }
}
.selected {
  color: #a30014;
}
.list-main {
  padding: 10px;
  .list-item {
    background-color: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 15px;
    margin-bottom: 5px;
    .site-info {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      // height: 60px;
      padding: 3px 8px 3px 12px;
      font-size: 16px;
      border-bottom: 1px solid #d7d7d7;
      .site-text {
        flex: 1;
        div {
          display: flex;
          align-items: center;
          padding: 2px 5px;
        }
      }
      .express-num {
        color: #a30014;
        border-radius: 50%;
        font-size: 14px;
      }
    }

    .express-item {
      display: flex;
      padding: 3px 0;
      margin: 5px 12px;
      border-bottom: 1px solid #d7d7d7;
      .logo {
        display: flex;
        align-items: center;
      }

      .detail {
        flex: 1;

        .code {
          font-size: 16px;
          font-weight: 700;
        }

        div {
          display: flex;
          align-items: center;
          padding: 2px 10px;
        }
      }
      .committed {
        font-size: 14px;
        margin-right: 5px;
        color: #a30014;
      }
    }

    .oneClick {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;
      padding: 0 10px 10px;
      .btn,
      .expand {
        margin-right: 10px;
        padding: 0 25px;
        border-radius: 5px;
      }
      .expand {
        box-sizing: border-box;
        border: 1px solid #a30014;
        height: 32px;
        color: #a30014 !important;
      }
    }
  }
}
.van-pull-refresh {
  height: calc(100vh - 42px) !important;
  overflow: auto !important;
}
</style>
